// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__1dFZc","section1":"Layout_section1__3Blqw"};